import React from "react";
import { useTranslation } from "react-i18next";
import packageJson from "../../../package.json";
import { Link, Stack, Typography } from "@mui/material";
import useColors from "utils/useColors/useColors";
import useConfig from "utils/useConfig/useConfig";

const Footer = () => {
  const { t } = useTranslation();
  const c = useColors();
  const { config } = useConfig();

  const year = new Date().getFullYear();

  return (
    <Stack width="100%" direction="row" justifyContent="space-between" alignItems="center"
      sx={{
        backgroundColor: c["brandBluegrey1"],
        minHeight: "100px",
      }}>
      <Stack direction="column" justifyContent="flex-start" sx={{ paddingLeft: "10%" }}>
        <Typography variant="content-footer">
          {t("layout.footer.copyright", { year })}
        </Typography>
        <Typography variant="content-footer">
          {t("layout.footer.version", { version: packageJson.version })}
        </Typography>
      </Stack>
      <Stack direction="column" justifyContent="flex-start" sx={{ paddingRight: "10%" }}>
        <Link
          variant="content-footer"
          color={c["brand1"]}
          underline="none"
          target="_blank"
          href={config.TERMS_OF_USE}
        >
          {t("layout.footer.terms")}
        </Link>
        <Link
          variant="content-footer"
          color={c["brand1"]}
          underline="none"
          target="_blank"
          href={config.PRIVACY_POLICY}
        >
          {t("layout.footer.privacy")}
        </Link>
      </Stack>
    </Stack>
  );
};

export default React.memo(Footer);
